import LoadingPage from 'components/LoadingPage';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from 'store/authStore';
import {
  AccessLevel,
  haveAccess,
  haveRole,
  PAGES_ENUM,
  USER_ROLES_ENUM,
} from 'utils/authenticationUtils';

interface ProtectedRouteProps extends PropsWithChildren {
  role?: USER_ROLES_ENUM;
  page?: PAGES_ENUM;
}

const ProtectedRoute = ({ page, role, children }: ProtectedRouteProps) => {
  const { token, tollingAdminAccessObject } = useAuthStore();

  if (!token) {
    return <LoadingPage />;
  }

  if (!tollingAdminAccessObject) {
    return <LoadingPage />;
  }

  if (role && !haveRole(role)) {
    return <Navigate to="/" replace />;
  }

  if (page) {
    if (!haveAccess(page, AccessLevel.VIEW)) {
      return <Navigate to="/" replace />;
    }
  }

  if (!page && !role) {
    return (
      <>
        <div className="bg-red-400 text-black">No protection on this path</div>
        {import.meta.env.MODE !== 'production' && children}
      </>
    );
  }

  return children;
};

export default ProtectedRoute;
